import React, { useState } from 'react';
import { Dropdown, CnIcon } from '@alife/cn-ui';
import OPButton from '../op-button';
import './index.scss';
export default function OPMenuButton(props) {
    const { children, label } = props;
    const [visible, setVisible] = useState(false);
    const trigger = (React.createElement(OPButton, { size: 'small', className: 'op-menu-button-trigger', type: 'secondary' },
        label,
        React.createElement(CnIcon, { type: visible ? 'triangle-up-fill' : 'triangle-down-fill', size: 'large' })));
    return (React.createElement(Dropdown, { trigger: trigger, triggerType: ['click'], onVisibleChange: setVisible, cache: true },
        React.createElement("div", { className: 'op-menu-button-dropdown' }, children)));
}
